// extracted by css-extract-rspack-plugin
export default {"tableControlsContainer":"tableControlsContainer-uHU5x3","tableControlsItemIcon":"tableControlsItemIcon-F6l29_"};